import React, { useMemo } from 'react';
import { Menu } from 'semantic-ui-react';
import {
    useChartStoreDataSources,
    useChartStoreActiveDataSourceTab,
    useChartStoreDataSourceActions,
} from '../../../../context';
import { groupByCompany } from './utils';
import FieldRow from './components/fieldRow';

function CompanyGroupedSidebar() {
    const dataSources = useChartStoreDataSources();
    const activeTab = useChartStoreActiveDataSourceTab();
    const { setActiveTab } = useChartStoreDataSourceActions();

    const isSingleSource = dataSources.length === 1;
    const activeSource = dataSources.find((s) => s.id === activeTab) ?? null;

    const companyGroups = useMemo(() => groupByCompany(dataSources), [dataSources]);

    const useNestedTabs = companyGroups.size > 1 && [...companyGroups.values()].some((g) => g.length > 1);

    const activeCompanyId = activeSource?.companyId ?? null;
    const activeCompanySources = activeCompanyId !== null ? companyGroups.get(activeCompanyId) ?? [] : [];

    return (
        <div className="chart-field-sidebar">
            {useNestedTabs ? (
                <>
                    <Menu vertical fluid size="small" className="chart-field-sidebar__tabs">
                        {[...companyGroups.entries()].map(([companyId, sources]) => (
                            <Menu.Item
                                key={companyId}
                                active={activeCompanyId === companyId}
                                onClick={() => setActiveTab(sources[0].id)}
                                className="chart-field-sidebar__tab"
                            >
                                {sources[0].companyName}
                            </Menu.Item>
                        ))}
                    </Menu>
                    {activeCompanySources.length > 1 && (
                        <div className="chart-field-sidebar__schema-tabs">
                            {activeCompanySources.map((source) => (
                                <button
                                    key={source.id}
                                    type="button"
                                    className={`chart-field-sidebar__schema-tab${activeTab === source.id ? ' chart-field-sidebar__schema-tab--active' : ''}`}
                                    onClick={() => setActiveTab(source.id)}
                                >
                                    {source.schemaName}
                                </button>
                            ))}
                        </div>
                    )}
                </>
            ) : (
                !isSingleSource && dataSources.length > 0 && (
                    <Menu vertical fluid size="small" className="chart-field-sidebar__tabs">
                        {dataSources.map((source) => (
                            <Menu.Item
                                key={source.id}
                                active={activeTab === source.id}
                                onClick={() => setActiveTab(source.id)}
                                className="chart-field-sidebar__tab"
                            >
                                {source.label}
                            </Menu.Item>
                        ))}
                    </Menu>
                )
            )}

            <div className="chart-field-sidebar__fields">
                {activeSource && (
                    <table>
                        <tbody>
                            {Object.keys(activeSource.fieldsCfg).map((fieldId) => (
                                <FieldRow key={fieldId} sourceId={activeTab!} fieldId={fieldId} />
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
}

export default React.memo(CompanyGroupedSidebar);
